import { useEffect, useState } from "react";
import useWindowSize from "./useWindowSize";
import { DESKTOP_VIEW_PX } from "constants/constants";

function useIsMobile() {
  const [isMobile, setIsmobile] = useState(false);
  const windowSize = useWindowSize();
  useEffect(() => {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
        navigator.userAgent
      ) ||
      (windowSize.width && windowSize?.width < DESKTOP_VIEW_PX)
    ) {
      // it is a mobile device
      setIsmobile(true);
    } else {
      setIsmobile(false);
    }
  }, [windowSize]);
  return isMobile;
}

export default useIsMobile;
